import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import NumberOptions from '../../types/NumberOptions';
import { INumberView } from '../../interfaces/INumberView';

interface SearchNumbersAlgoliaResponse {
  hits: INumberView[];
  nbHits: number;
  exactNbHits: number;
  page: number;
}

async function searchNumbers(
  auth: Authentication | null,
  query: string,
  page = 0,
  hitsPerPage = 20,
  filters?: NumberOptions
): Promise<SearchNumbersAlgoliaResponse> {
  try {
    if (!auth) {
      throw new SearchNumbersAlgoliaFailure(
        'Vous devez être connecté pour effectuer cette action.',
        'unauthorized'
      );
    }

    const params = new URLSearchParams({
      q: query,
      page: String(page),
      hitsPerPage: String(hitsPerPage),
    });

    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;
        if (Array.isArray(value)) {
          value.forEach((entry) => params.append(`${key}[]`, String(entry)));
        } else {
          params.append(key, String(value));
        }
      });
    }

    const json = await HttpClient.get(
      `/algolia/search/backoffice/numbers?${params.toString()}`,
      auth.token
    );

    return { hits: json.hits, nbHits: json.nbHits, exactNbHits: json.exactNbHits, page };
  } catch (e) {
    if (e instanceof SearchNumbersAlgoliaFailure) throw e;
    throw new SearchNumbersAlgoliaFailure();
  }
}

export class SearchNumbersAlgoliaFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default searchNumbers;
